import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useUsersStore = defineStore('users', {
  state: () => ({
    users: [],
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalUsers: 0,
    totalPages: 1
  }),
  actions: {
    async fetchUsers({ page, rows, search, perPage } = {}) {
      try {
        const response = await api.get('/usuarios', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage
          }
        })
        this.users = response.data.items
        this.totalUsers = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        console.log('this.users', this.users)
        return this.users
      } catch (error) {
        console.error('Error al obtener usuarios:', error)
        throw error
      }
    },
    async createUser(user) {
      try {
        const response = await api.post('/usuarios', user, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.users.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error al crear usuario:', error)
        throw error
      }
    },
    async updateUser(user) {
      try {
        const response = await api.put(`/usuarios/${user.id}`, user, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.users.findIndex((u) => u.id === user.id)
        if (index !== -1) {
          this.users[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar usuario:', error)
        throw error
      }
    },
    async deleteUser(id) {
      try {
        await api.delete(`/usuarios/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.users = this.users.filter((u) => u.id !== id)
      } catch (error) {
        console.error('Error al eliminar usuario:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getUser(id) {
      try {
        const response = await api.get(`/usuarios/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener usuario:', error)
        throw error
      }
    }
  }
})
